import React, { ReactNode } from 'react';

import { Box } from '@adsk/alloy-react-box';
import Checkbox, { CheckboxState } from '@adsk/alloy-react-checkbox';

function CheckboxFilter({
  title,
  onChange,
  checked,
  name,
}: {
  title: ReactNode;
  name: string;
  checked: boolean;
  onChange: (key: string, value: boolean | string) => void;
}) {
  return (
    <Box
      display="grid"
      gridAutoFlow="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ columnGap: '12px' }}
    >
      <Checkbox
        id={`${name}Checkbox`}
        onChange={(state: CheckboxState) => onChange(name, state)}
        checked={checked}
      />
      <label htmlFor={`${name}Checkbox`}>{title}</label>
    </Box>
  );
}

export default CheckboxFilter;
